<div class="interest-form-wrapper">
    <div class="form-card">
        
    <div class="form-header">
        <div class="logo-box">
            <img src="assets/aze.png" alt="AzeApp Icon" />
        </div>
        <div class="header-title">
            <span>AzeApp Interest Registration</span>
        </div>
    </div>
  
      <form [formGroup]="interestForm" (ngSubmit)="submitForm()">
        <div class="form-group">
          <label for="name">Name <span class="required">*</span></label>
          <input type="text" id="name" formControlName="name" placeholder="Enter your full name"
            autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
            <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.name.errors.required">
                  Name is required
                </div>
            </div>
        </div>
  
        <div class="form-group">
          <label for="mobileNo">Mobile Number <span class="required">*</span></label>
          <input type="tel" id="mobileNo" formControlName="mobileNo" placeholder="e.g. 9876543210" 
            autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.mobileNo.errors }">
            <div *ngIf="submitted && f.mobileNo.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.mobileNo.errors.required">
                    Mobile Number is required
                </div>
                <div *ngIf="f.mobileNo.errors.pattern">
                    Enter a valid 10-digit mobile number
                  </div>
            </div>
        </div>
  
        <div class="form-group">
          <label for="remarks">Remarks</label>
          <textarea id="remarks" formControlName="remarks" rows="3" placeholder="Share your interest in AzeApp"></textarea>
        </div>
  
        <div class="form-group form-checkbox">
          <input type="checkbox" id="consent" formControlName="consent" />
          <label for="consent">I agree to be contacted by AzeApp via WhatsApp or phone.</label>
        </div>
  
        <button type="submit" class="btn-register">
          Register
        </button>
      </form>
    </div>
  </div>